import { Badge } from '@chakra-ui/react';

const statusConfig = {
  open: { colorScheme: 'green', label: 'Open' },
  claimed: { colorScheme: 'blue', label: 'Claimed' },
  in_review: { colorScheme: 'purple', label: 'In Review' },
  completed: { colorScheme: 'gray', label: 'Completed' },
  cancelled: { colorScheme: 'red', label: 'Cancelled' },
  pending: { colorScheme: 'yellow', label: 'Pending' },
  under_review: { colorScheme: 'purple', label: 'Under Review' },
  approved: { colorScheme: 'green', label: 'Approved' },
  rejected: { colorScheme: 'red', label: 'Rejected' },
  disputed: { colorScheme: 'orange', label: 'Disputed' },
  resolved: { colorScheme: 'blue', label: 'Resolved' },
  closed: { colorScheme: 'gray', label: 'Closed' },
  succeeded: { colorScheme: 'green', label: 'Succeeded' },
  failed: { colorScheme: 'red', label: 'Failed' },
  manually_verified: { colorScheme: 'blue', label: 'Manually Verified' },
};

export const StatusBadge = ({ status }) => {
  const config = statusConfig[status] || { colorScheme: 'gray', label: status };

  return (
    <Badge colorScheme={config.colorScheme} fontSize="sm" px={2} py={1} rounded="md">
      {config.label}
    </Badge>
  );
};
